import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormCodeSn } from '../models/form/form-code-sn.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmFormCodeSnService extends RequestService<FormCodeSn> {
  static PATH = '/om/form/code/sn';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmFormCodeSnService.PATH, globalService.debugUrl);
  }
}
